import React from 'react';
import { MailIcon } from './icons';

export interface SidebarUtilityDockProps {
  onOpenChannelModal?: () => void;
  onOpenVoiceOverlay?: () => void;
  onToggleNotifications?: () => void;
  unreadNotifications?: number;
}

export const SidebarUtilityDock: React.FC<SidebarUtilityDockProps> = ({
  onOpenChannelModal,
  onOpenVoiceOverlay,
  onToggleNotifications,
  unreadNotifications = 0,
}) => {
  return (
    <div
      style={{
        marginTop: 'auto',
        padding: '8px 10px',
        borderTop: '1px solid var(--theme-border, #1e293b)',
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <button
          type="button"
          data-testid="btn-open-channel-mgmt"
          onClick={onOpenChannelModal}
          className="has-tooltip tooltip-up"
          data-tooltip="Open Channels Manager"
          aria-label="Open Channels Manager"
          style={{
            flex: 1,
            background: 'var(--theme-bg-card, #151d2a)',
            border: '1px solid var(--theme-border, #1e293b)',
            borderRadius: '5px',
            padding: '4px 6px',
            color: 'var(--theme-text-primary, #f8fafc)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '13px',
            lineHeight: 1,
          }}
        >
          <span>🎛️</span>
        </button>

        <button
          type="button"
          data-testid="btn-open-voice-overlay"
          onClick={onOpenVoiceOverlay}
          className="has-tooltip tooltip-up"
          data-tooltip="Open Voice AI"
          aria-label="Open Voice AI"
          style={{
            flex: 1,
            background: 'var(--theme-bg-card, #151d2a)',
            border: '1px solid var(--theme-border, #1e293b)',
            borderRadius: '5px',
            padding: '4px 6px',
            color: 'var(--theme-text-primary, #f8fafc)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '13px',
            lineHeight: 1,
          }}
        >
          <span>🎙️</span>
        </button>
      </div>

      {onToggleNotifications && (
        <button
          type="button"
          onClick={onToggleNotifications}
          className="has-tooltip tooltip-up"
          data-tooltip={unreadNotifications > 0 ? `${unreadNotifications} unread notifications` : 'Notifications inbox'}
          aria-label={unreadNotifications > 0 ? `${unreadNotifications} unread notifications` : 'Notifications inbox'}
          style={{
            position: 'relative',
            background: 'var(--theme-bg-card, #151d2a)',
            border: '1px solid var(--theme-border, #1e293b)',
            borderRadius: '5px',
            padding: '4px 7px',
            color: unreadNotifications > 0 ? 'var(--theme-accent, #60a5fa)' : 'var(--theme-text-secondary, #64748b)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            fontSize: '11px',
            fontWeight: 600,
          }}
        >
          <MailIcon size={13} color="currentColor" />
          <span>Inbox</span>
          {unreadNotifications > 0 && (
            <span
              style={{
                backgroundColor: 'var(--theme-danger, #ef4444)',
                color: 'white',
                fontSize: '9px',
                fontWeight: 800,
                minWidth: '15px',
                height: '15px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 3px',
                marginLeft: 'auto',
              }}
            >
              {unreadNotifications}
            </span>
          )}
        </button>
      )}
    </div>
  );
};
